import ComplianceModal from "./Modal";

export { ComplianceModal };
